module.exports = __webpack_public_path__ + "images/cv_bulk_btn03_65ff1320b8199a08e4e5b3333b48bccb.png";